module.exports = __webpack_public_path__ + "static/media/chevron-bottom.7f0eaaf6.svg";